module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "befriend.7e2f8e84.webp";